import { render, staticRenderFns } from "./RoundedPillSvg.vue?vue&type=template&id=a371f758&"
import script from "./RoundedPillSvg.vue?vue&type=script&lang=ts&"
export * from "./RoundedPillSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports